webpackJsonp([38],{

/***/ 0:
/***/ (function(module, exports) {


var isIE = function isIE() {
	return !!window.ActiveXObject || "ActiveXObject" in window;
},
    ltIE9 = function ltIE9() {
	var browser = navigator.appName,
	    b_version = navigator.appVersion,
	    version = b_version.split(";");

	if (version.length > 1) {
		var trim_Version = parseInt(version[1].replace(/[ ]/g, "").replace(/MSIE/g, ""));
		if (trim_Version < 9) {
			return true;
		}
	}

	return false;
},
    loadAsync = function loadAsync(src, callback) {
	if (typeof src === 'string') {
		src = [src];
	}

	for (var i = 0; i < src.length; i++) {
		var script = document.createElement('script');
		script.src = src[i];

		if (callback && $.type(callback) === 'function' && i + 1 === src.length) {
			script.onreadystatechange = function () {
				if (script.readyState === 'loaded' || script.readyState === 'complete') {
					callback();
				}
			};
		}
		document.body.appendChild(script);
	}
},
    queryString = function queryString(name, targetStr) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	var r;
	if (!targetStr) {
		r = window.location.search.substr(1).match(reg);
	} else {
		r = targetStr.match(reg);
	}
	return r != null ? unescape(r[2]) : null;
},
    addDays = function addDays(d1, num, sep) {
	sep = sep || '-';
	num = num || 0;
	if (typeof d1 === 'string') d1 = new Date(d1.replace(/-/g, '/'));
	return new Date(+d1 + num * 24 * 60 * 60 * 1000).Format('yyyy' + sep + 'MM' + sep + 'dd');
},
    throttle = function throttle(func, option, timeGap, context) {

	timeGap = timeGap || 300;

	clearTimeout(func.tId);

	func.tId = setTimeout(function () {
		func.call(context, option);
	}, timeGap);
},
    login = function login() {
	location.href = '/user/home.do';
},
    tipShowAndHide = function tipShowAndHide(_this, msg, options) {
	var tip = layer.tips(msg, _this, $.extend(true, {
		time: 0,
		tips: [1, '#FFFFF3']
	}, options));

	_this.one('mouseleave', function () {
		layer.close(tip);
	});
},
    formatOne = function formatOne(str) {
	return str.replace(/\//g, '-');
},
    CloseWebPage = function CloseWebPage() {
	if (navigator.userAgent.indexOf("MSIE") > 0) {
		if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
			window.opener = null;
			window.close();
		} else {
			window.open('', '_top');
			window.top.close();
		}
	} else if (navigator.userAgent.indexOf("Firefox") > 0) {
		window.location.href = 'about:blank ';
	} else {
		window.opener = null;
		window.open('', '_self', '');
		window.close();
	}
};

module.exports = {
	isIE: isIE,
	ltIE9: ltIE9,
	login: login,
	addDays: addDays,
	loadAsync: loadAsync,
	queryString: queryString,
	throttle: throttle,
	tipShowAndHide: tipShowAndHide,
	formatOne: formatOne,
	CloseWebPage: CloseWebPage
};

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(10);

module.exports = function (option) {
	var loginTpl = __webpack_require__(11)();
	var event = window.event || arguments.callee.caller.arguments[0];

	if (!option) {
		layer.open({
			type: 1,
			title: false,
			area: ['360px', '422px'],

			content: loginTpl,
			success: function success() {
				__webpack_require__(2).run();
			}
		});
	}

	if (option) {
		if (option.position === 'mask') {
			layer.open({
				type: 1,
				title: false,
				area: ['360px', '422px'],

				content: loginTpl,
				success: function success() {
					__webpack_require__(2).run();
				}
			});
		} else if (option.position === 'below') {
			if (!option.target) {
				option.target = event.target || event.srcElement;
			}

			var left = +$(option.target).offset().left,
			    top = +$(option.target).offset().top,
			    height = +$(option.target).height();

			if ($('body .login-box').length <= 0) {
				$('body').append(loginTpl);
			} else {
				$('div').remove('.login-box');
				return;
			}

			$('.login-box').css({
				'position': 'absolute',
				'left': left - 180 + 'px',
				'top': top + height + 'px',
				'z-index': '19950311'
			});
		}
	}
};

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="login-box">\r\n    <form id="loginJl">\r\n        <!--<h2>房掌柜登录</h2>-->\r\n        <ul>\r\n            <li>\r\n                <i class="login-icon login-icon-1"></i>\r\n                <input placeholder="企业编号" id="accountCode" title="企业编号" name="accountCode" autocomplete="off" emptymsg="* 企业编号不能为空" type="text">\r\n            </li>\r\n            <li>\r\n                <i class="login-icon login-icon-2"></i>\r\n                <input placeholder="用户名/手机号/邮箱" id="username" title="用户名/手机号/邮箱" name="username" autocomplete="off" emptymsg="* 用户名不能为空" type="text">\r\n            </li>\r\n            <li>\r\n                <i class="login-icon login-icon-3"></i>\r\n                <input placeholder="密码" id="password" title="密码" name="password" autocomplete="off" emptymsg="* 请输入密码" type="password">\r\n            </li>\r\n            <li class="yzm-box">\r\n                <i class="login-icon login-icon-4"></i>\r\n                <input placeholder="请输入验证码" id="checkcode" title="请输入验证码" name="checkcode" emptymsg="* 请输入验证码" type="text" autocomplete="off">\r\n                <img class="yzm-img" src="/user/getCheckcodeImg.do?time=' +
((__t = (new Date().getTime())) == null ? '' : __t) +
'" alt=""/>\r\n            </li>\r\n        </ul>\r\n        <p class="err-msg"></p>\r\n        <button id="loginIn">登录</button>\r\n        <div class="login-bottom">\r\n            <input id="remberCode" name="rememberMe" type="checkbox" value="true">\r\n            <label for="remberCode">记住账号</label>\r\n            <a class="find-password" href="/user/password/toForgetPage.do">忘记密码？</a>\r\n            <a class="register" href="/user/toRegister.do" target="_blank" data-track="房掌柜首页_登录框_免费注册">免费注册</a>\r\n        </div>\r\n    </form>\r\n</div>';

}
return __p
}

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(13);
var Util = __webpack_require__(0);
var loginModel = __webpack_require__(3);
var CloseWebPage = __webpack_require__(0).CloseWebPage;

function getCurUser(pagename) {
    $('.i-t-n-group').find('li[data-module="' + pagename + '"]').attr('checked', 'checked');

    $.post('/user/getCurrentUser.do', {}, function (res) {
        if (res.returnCode == 1) {
            getSales();

            $('.i-t-n-user-wrap').hover(function () {
                $('.i-t-n-user-wrap:hover .i-t-n-drops').css('display', 'none');
            });

            window.hasLoginFzg = 'true';

            var noticeHtml = '\n            <a href="/myinfo/toMyInfoHome.do?index=17" class="link-href-a">\n                <div class="gonggao-icon"></div>\n            </a>\n            ';
            $('.notice-icon-container').append(noticeHtml);

            window.distrbCode = res.data.distributorAccount.distrbCode;
            window.isAdmin = res.data.user.isAdmin;
            if (res.data.temporaryDemand1470) {
                window.temporaryDemand1470 = JSON.parse(res.data.temporaryDemand1470);
            }

            if (window.isAdmin == null) window.isAdmin = 'null';

            $(".i-t-n-user").html(res.data.user.customerUserName).attr('data-distrbid', res.data.distributorAccount.distrbId).attr('data-type', res.data.user.type).attr('data-suppid', res.data.user.suppId).attr('data-isadmin', res.data.user.isAdmin);
            sessionStorage.setItem('login', 'login');

            if (pagename === 'toolDataIn') {
                if (res.data.distributorAccount.distrbCode.toUpperCase() !== 'SZ2747') {
                    alert('您不被允许进入该页面', {
                        closeBtn: 0
                    }, function () {
                        CloseWebPage();
                    });
                }
            } else if (pagename === 'toolOperateHotel') {
                if (res.data.user.isAdmin !== 1) {
                    alert('您不被允许进入该页面', {
                        closeBtn: 0
                    }, function () {
                        CloseWebPage();
                    });
                }
            }

            if (res.data.isFirstLoginAfterRegister) {
                __webpack_require__(14)();
            }
        } else if (res.returnCode == -400001) {
            window.hasLoginFzg = 'false';

            var _noticeHtml = '\n            <div class="gonggao-icon is-link-show"></div>\n            ';
            $('.notice-icon-container').append(_noticeHtml);

            $('.index-concern-order-outer').css('display', 'none');

            $('.need-to-hide-without-login').hide();

            if (pagename === 'index' || pagename === 'register' || pagename === 'noLogin' || pagename === 'hotelList2' || pagename === 'ticket' || pagename === 'groupRoom') {

                $('.i-t-n-triangle').hide();

                $('.i-t-n-user-wrap').hover(function () {
                    $('.i-t-n-user-wrap:hover .i-t-n-drop').css('display', 'none');
                }).click(function () {
                    __webpack_require__(1)();
                });
            } else {
                Util.login();
            }
        }
    }, 'noAnimation');
}

function getSales() {
    $.post('/myinfo/getMyInfo.do', { salesman: 1 }, function (res) {
        if (res.returnCode == 1) {
            var html = '\n                <div class="number-css">\n                    <div class="bold-css">\u4E13\u5C5E\u9500\u552E\u7ECF\u7406\uFF1A</div>\n                </div>\n                <div class="lianxi-all">\n                    <div class="lianxi-ren">\n                        <div class="people-icon"></div>\n                        <div class="concat-over">' + (res.data.salesman.realname || " -") + '</div>\n                    </div>\n                    <div class="lianxi-ren">\n                        <div class="phone-icon"></div>\n                        <div class="concat-over">' + (res.data.salesman.cellphone || " -") + '</div>\n                    </div>\n                    <div class="lianxi-ren">\n                        <div class="email-icon"></div>\n                        <div class="concat-over">' + (res.data.salesman.email || " -") + '</div>\n                    </div>\n                </div>\n            ';
            $(".mySalesMan").append(html);
        } else {}
    }, "noAnimation");
}

function initLogout() {
    $("#logout").on('click', function () {
        var loginoutConfirm = confirm('是否确定退出？', function () {
            $.post('/user/loginoutfzg.do', {}, function (res) {
                if (res && res.returnCode == 1) {
                    $(".i-t-n-user").html("请登录");
                    layer.close(loginoutConfirm);
                    location.reload();
                }
            });
        });
    });
}

function navbarLink() {
    $('.i-t-n-group>li[name="i-t-n-radio"]>a').click(function () {
        if ($(this).attr('data-module') === 'group') {
            __webpack_require__(1)();

            return false;
        }
    });
}

function initClick() {
    $('.i-t-n-drops').click(function (event) {
        window.open("http://en-cn.jl-tour.com/");
        event.stopPropagation();
        event.preventDefault();
    });
}

function clickNoticeIcon() {
    $(document).delegate(".is-link-show", "click", function () {
        layer.msg('请先登录');

        window.setTimeout(function () {
            __webpack_require__(1)();
        }, 1000);
    });
}

module.exports = {
    run: function run(pagename) {
        getCurUser(pagename);

        initLogout();

        navbarLink();

        clickNoticeIcon();
    }
};

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(15);

module.exports = function (option) {
    var str = __webpack_require__(16)();

    if (!option) {
        layer.open({
            type: 1,
            title: false,

            content: str
        });
    }
};

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="prompt-box">\r\n    <div class="prompt-head">\r\n        <h6 class="prompt-title">温馨提示</h6>\r\n    </div>\r\n\r\n    <div class="prompt-content">为避免账户信息泄露， 建议您前往个人中心修改初始密码</div>\r\n\r\n    <button class="jump-btn">\r\n        <a href="/myinfo/toMyInfoHome.do?resetPassword=true">立即修改</a>\r\n    </button>\r\n</div>';

}
return __p
}

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

var firstPageApi = {
	login: '/user/loginfzg.do',
	isLogin: '/user/getCurrentUser.do',
	loginout: '/user/loginoutfzg.do'
};

function loginJl() {
	$('#loginIn').click(function () {
		$('.err-msg').text('');

		$('#loginJl>ul>li').removeClass('li-error');

		$(this).text('登录中…');

		var allInput = $('#loginJl').find('input[emptymsg]');

		var loginFlag = "true";
		for (var aI = 0; aI < allInput.length; aI++) {
			var $requireInput = $(allInput[aI]);
			if (!$requireInput.val()) {
				loginFlag = "false";
				$('.err-msg').text($requireInput.attr('emptymsg'));

				$requireInput.parent().addClass('li-error');

				$(this).text('登录');
				break;
			}
		}

		if (loginFlag == "true") {
			var rememberMe = '';
			if ($('input[name="rememberMe"]').is(':checked')) {
				rememberMe = 'true';
			} else {
				rememberMe = 'false';
			}
			var paramObj = {
				accountCode: $.trim($('#accountCode').val()),
				username: $.trim($('#username').val()),
				password: $('#password').val(),
				checkcode: $('#checkcode').val(),
				rememberMe: rememberMe
			};

			$.post(firstPageApi.login, paramObj, function (data) {
				if (data.returnCode) {
					if (data.returnCode != 1) {
						$('.err-msg').text('*' + data.returnMsg);
						$('.yzm-img').trigger('click');
						$('#loginIn').text('登录');
					} else {
						if ($.trim(paramObj.accountCode).length > 0) {
							var record_data = encodeURIComponent(paramObj.accountCode.toUpperCase());
							$.get("/count/record.do?t=ActiveDistrb&d=" + record_data);
						}

						var loginAccount = localStorage.getItem("LoginAccount");
						if (!loginAccount || loginAccount != paramObj.accountCode) {
							localStorage.setItem("LoginAccount", paramObj.accountCode);
						}
						var LoginUsername = localStorage.getItem("LoginUsername");
						if (!LoginUsername || LoginUsername != paramObj.username) {
							localStorage.setItem("LoginUsername", paramObj.username);
						}

						layer.closeAll();
						location.reload();
					}
				} else {
					alert('系统繁忙，请稍后重试');
					$('#loginIn').text('登录');
				}
			});
		}

		return false;
	});
}

function other() {
	$('.yzm-img').click(function () {
		$(this).attr('src', '/user/getCheckcodeImg.do?time=' + new Date().getTime());
	});
}

function getCookie(name) {
	var strcookie = document.cookie;
	var arrcookie = strcookie.split("; ");
	for (var i = 0; i < arrcookie.length; i++) {
		var arr = arrcookie[i].split("=");
		if (arr[0] == name) {
			return arr[1];
		}
	}
	return "";
}

module.exports = {
	run: function run() {
		if (getCookie('login_account_code_cookie')) {
			$('input[name="accountCode"]').val(getCookie('login_account_code_cookie'));
			$('input[name="username"]').val(decodeURIComponent(getCookie('login_user_name_cookie')));
			$('input[name="rememberMe"]').attr('checked', 'true');
		}

		loginJl();

		other();
	}
};

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(7);
__webpack_require__(8);

function validate_1(accountCode, flag) {
    return common_validate(accountCode, "f-error1", "公司账号不能为空！", flag);
}

function validate_2(username, flag) {
    return common_validate(username, "f-error2", "用户名不能为空！", flag);
}

function validate_3(password, flag) {
    return common_validate(password, "f-error3", "密码不能为空！", flag);
}

function validate_4(checkcode, flag) {
    return common_validate(checkcode, "f-error4", "验证码不能为空！", flag);
}

function validate(param, flag) {

    if (!validate_1(param.accountCode, flag)) return false;

    if (!validate_2(param.username, flag)) return false;

    if (!validate_3(param.password, flag)) return false;

    if (!validate_4(param.checkcode, flag)) return false;
    if ($("#validateMsg" + flag).hasClass("f-error1") || $("#validateMsg" + flag).hasClass("f-error2") || $("#validateMsg" + flag).hasClass("f-error3") || $("#validateMsg" + flag).hasClass("f-error4")) return false;

    return true;
}

function login(param, flag) {
    if (!validate(param, flag)) {
        $('.yzmlogin').attr('src', '/user/getCheckcodeImg.do?time=' + new Date().getTime());
        return false;
    }

    $("#loadingImg" + flag).removeClass("hidden");
    $("#p1_RightBody" + flag + " .loginBody").addClass("hidden");

    if (param && param.accountCode && param.username && param.password && param.checkcode) {
        $.post("/user/loginfzg.do", param, function (data) {
            if (data.returnCode === 1) {
                if ($.trim(param.accountCode).length > 0) {
                    $.get("/count/record.do?t=ActiveDistrb&d=" + param.accountCode.toUpperCase());
                }

                var loginAccount = localStorage.getItem("LoginAccount");
                if (!loginAccount || loginAccount != param.accountCode) {
                    localStorage.setItem("LoginAccount", param.accountCode);
                }
                var LoginUsername = localStorage.getItem("LoginUsername");
                if (!LoginUsername || LoginUsername != param.username) {
                    localStorage.setItem("LoginUsername", param.username);
                }

                $("#div_User").attr('data-distrb', param.accountCode);
                sessionStorage.setItem('login', 'login');
                layer.closeAll();

                location.reload();
            } else {
                $('.yzmlogin').attr('src', '/user/getCheckcodeImg.do?time=' + new Date().getTime());
                showErrorMsg(data.msg, flag);
            }

            $("#loadingImg" + flag).addClass("hidden");
            $("#p1_RightBody" + flag + " .loginBody").removeClass("hidden");
        });
    }
}

function removeErrorMsg(flag) {
    $("#validateMsg" + flag).html("");
    $("#validateMsg" + flag).addClass("hidden");

    if (flag == 1) {
        $("#p1_RightBody1 .loginBody").css("height", "277px");
        $("#loginBody2").css("padding-top", "22px");
    } else if (flag == 2) {
        $("#p1_RightBody2 .loginBodyRow").css("margin-top", "15px");
    }
}

function showErrorMsg(msg, flag) {
    $("#validateMsg" + flag).html("* " + msg);
    $("#validateMsg" + flag).removeClass("hidden");

    if (flag == 1) {
        $("#p1_RightBody1 .loginBody").css("height", "305px");
        $("#loginBody2").css("padding-top", "14px");
    } else if (flag == 2) {
        $("#p1_RightBody2 .loginBodyRow").css("margin-top", "12px");
    }
}

function handleErrorMsg(flag) {
    if ($("#validateMsg" + flag).hasClass("f-error1")) {
        showErrorMsg("公司账号不能为空！", flag);
        return false;
    }

    if ($("#validateMsg" + flag).hasClass("f-error2")) {
        showErrorMsg("用户名不能为空！", flag);
        return false;
    }

    if ($("#validateMsg" + flag).hasClass("f-error3")) {
        showErrorMsg("密码不能为空！", flag);
        return false;
    }

    if ($("#validateMsg" + flag).hasClass("f-error4")) {
        showErrorMsg("验证码不能为空！", flag);
        return false;
    }

    removeErrorMsg(flag);
    return true;
}

function common_validate(value, className, errorMsg, flag) {
    if (value === "") {
        $("#validateMsg" + flag).addClass(className);
        showErrorMsg(errorMsg, flag);
        return false;
    } else {
        $("#validateMsg" + flag).removeClass(className);
        handleErrorMsg(flag);
    }
    return true;
}

function initEvents() {
    var bind_name = 'input';
    var ver = navigator.userAgent;
    if (ver.indexOf("MSIE 6.0") != -1 || ver.indexOf("MSIE 7.0") != -1 || ver.indexOf("MSIE 8.0") != -1) {
        bind_name = 'propertychange';
    }

    $(".accountCode").bind(bind_name, function () {
        var flag = this.parentElement.parentElement.attributes["data-flag"].value;
        validate_1($("#p1_RightBody" + flag + " .accountCode").val().replace(" ", ""), flag);
    });

    $(".username").bind(bind_name, function () {
        var flag = this.parentElement.parentElement.attributes["data-flag"].value;
        validate_2($("#p1_RightBody" + flag + " .username").val().replace(" ", ""), flag);
    });

    $(".password").bind(bind_name, function () {
        var flag = this.parentElement.parentElement.attributes["data-flag"].value;
        validate_3($("#p1_RightBody" + flag + " .password").val().replace(" ", ""), flag);
    });

    $(".varificationCode").bind(bind_name, function () {
        var flag = this.parentElement.parentElement.attributes["data-flag"].value;
        validate_4($("#p1_RightBody" + flag + " .varificationCode").val().replace(" ", ""), flag);
    });

    $(document).delegate(".yzmlogin", 'click', function () {
        $(this).attr('src', '/user/getCheckcodeImg.do?time=' + new Date().getTime());
    });

    $(document).delegate(".registerBtn", 'click', function () {
        location.href = "/login/html/register.jsp";
    });

    $(document).delegate('#login_layer .loginBtn', 'click', function () {
        login({
            'accountCode': $("#p1_RightBody2 .accountCode").val().replace(" ", ""),
            'username': $("#p1_RightBody2 .username").val().replace(" ", ""),
            'password': $("#p1_RightBody2 .password").val().replace(" ", ""),
            'checkcode': $("#p1_RightBody2 .varificationCode").val().replace(" ", ""),
            'rememberMe': $("#rememberMe").is(':checked') === true ? "true" : "false"
        });
    });

    $(".accountCode,.username,.password,.varificationCode").on("keydown", function (e) {
        if (e.keyCode == 13) {
            $(this).closest(".loginBody").find(".loginBtn").click();
        }
    });
}

function loginFirst() {
    layer.open({
        type: 1,
        shade: ['0.25', 'rgb(0,0,0)'],
        title: false,
        content: __webpack_require__(9)(),
        area: ["290px", "350px"],
        cancel: function cancel(index) {
            layer.close(index);
        },
        success: function success(layero, index) {
            initEvents();
        }
    });
}

module.exports = {
    initEvents: initEvents,
    loginFirst: loginFirst
};

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(4);

__webpack_require__(12).run();
__webpack_require__(5).run();

__webpack_require__(362);

$('.pnf-btn').on('click', function () {
    window.location.href = "/user/bookHotel.do";
});

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(6);

var Util = __webpack_require__(0);

module.exports = {
    run: function run() {
        if (Util.ltIE9()) {
            alert('为了更好的使用体验，请不要使用IE浏览器，谢谢！');
        }
    }
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!-- 登录模块模板 -->\r\n<div id="login_layer">\r\n	<div id="p1_RightTop">\r\n		<span id="p1_RightTopSpan">会员登录</span>\r\n		<i id="loginTriangle" class="iconfont icon-triangle-down"></i>\r\n	</div>\r\n	\r\n	<div id="p1_RightBody2">\r\n		<form>\r\n			<div class="loginBody" data-flag="2">\r\n				<p id="validateMsg2" class="hidden">* 请输入验证码</p>\r\n				<div class="loginBodyRow">\r\n					<i class="iconfont icon-user"></i>\r\n					<i class="divider"></i>\r\n					<input placeholder="公司账号" title="公司账号" class="accountCode" name="account" />\r\n				</div>\r\n				<div class="loginBodyRow">\r\n					<i class="iconfont icon-user"></i>\r\n					<i class="divider"></i>\r\n					<input placeholder="用户名" title="用户名" class="username" name="username" />\r\n				</div>\r\n				<div class="loginBodyRow">\r\n					<i class="iconfont icon-password"></i>\r\n					<i class="divider"></i>\r\n					<input type="password" placeholder="密码" title="密码" class="password" name="password" />\r\n				</div>\r\n				<div class="loginBodyRow">\r\n					<i class="iconfont icon-varification"></i>\r\n					<i class="divider"></i>\r\n					<input class="varificationCode" />\r\n					<div>\r\n						<img src="/user/getCheckcodeImg.do?time=' +
((__t = ( new Date().getTime() )) == null ? '' : __t) +
'" class="yzmlogin" style="" />\r\n					</div>\r\n				</div>\r\n				<div id="rememberPW">\r\n					<span>\r\n						<input id="rememberMe" type="checkbox" />\r\n						<span>记住我...</span>\r\n					</span>\r\n					<a id="forgetPW" href="/user/password/toForgetPage.do"><span>忘记密码？</span></a>\r\n				</div>\r\n				<div class="loginBodyRow loginBtnGroup">\r\n					<a href="javascript:void(0);" class="registerBtn">注册</a>\r\n					<a href="javascript:void(0);" class="loginBtn submitBtn">登 录</a>\r\n				</div>\r\n			</div>\r\n		</form>\r\n	</div>\r\n</div>';

}
return __p
}

/***/ })

},[361]);


// WEBPACK FOOTER //
// js/pageNotFound/pageNotFound.8f2e9be120db3a9465b8.js